import { useMutation } from '@tanstack/react-query';
import request from '@utils/request';
import { Dispatch, SetStateAction } from 'react';
import { TranslationKey } from '@lang';

export const useRemoveVoucherCode = (
  propertyId: number,
  basketId: string | number,
  onSuccess: () => Promise<void>,
  setError: Dispatch<SetStateAction<TranslationKey | null>>
) => {
  return useMutation({
    mutationFn: async (code: string) => {
      const encodedCode = encodeURIComponent(code.trim());
      return await request.v2.delete(`${propertyId}/baskets/${basketId}/vouchers/${encodedCode}`);
    },
    onSuccess,
    onError: () => {
      setError('basket.errorApplyingCodeInvalid');
    },
  });
};
